export { DottedBackground } from "./DottedBackground";
export type { DottedBackgroundProps } from "./DottedBackground";
